import React, { Component } from 'react';
import PropTypes from 'prop-types';
import OptimizeImagesService from 'services/OptimizeImages.service';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import styles from './GroupCard.module.scss';

export default class GroupCard extends Component {
  static propTypes = {
    className: PropTypes.string,
    enterprise: PropTypes.object.isRequired
  };

  static defaultProps = {
    className: '',
    enterprise: {}
  };

  render() {
    const { className, enterprise } = this.props;

    return (
      <div
        className={`${styles.GroupCard} ${
          this.props.index === this.props.activeIndex ? styles.Visible : ''
        }  ${className} `}
      >
        <div className={styles.GroupCardLeftColumn}>
          <img
            alt="logo"
            src={OptimizeImagesService.adjustImageSize(enterprise.logo)}
          />
        </div>
        <div className={styles.GroupCardRightColumn}>
          <div className={styles.GroupCardHeader}>
            <h2 className={styles.GroupCardName}>{enterprise.title}</h2>
          </div>
          <div>
            <p
              className={styles.GroupCardAboutParagraph}
              dangerouslySetInnerHTML={{ __html: `${enterprise.description}` }}
            />
          </div>
          <div className={styles.GroupCardContactWrapper}>
            {enterprise.facebookLink && (
              <div className={styles.GroupCardContact}>
                <a
                  href={enterprise.facebookLink}
                  className={styles.GroupCardSocial}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                >
                  <FontAwesomeIcon icon={['fab', 'facebook-f']} />
                </a>
                <a
                  href={enterprise.facebookLink}
                  className={styles.GroupCardContactLink}
                  rel="nofollow"
                >
                  {enterprise.facebookLink}
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/CSR/components/GroupCard/GroupCard.js